module.exports = __webpack_public_path__ + "static/pushnami-45176bad25c71964366429c7e6782999.png";